import './index.scss';

import _ from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';

import { AppList } from './AppList/AppList';

const Apps = () => {
  const { projectId } = useParams<{ projectId: string }>();

  return (
    <React.Fragment>
      <div className="card-header">
        <h4 className="settingsMainTitle">Apps</h4>
      </div>

      <div className="settingsCardBody">
        <AppList projectId={projectId} />
      </div>
    </React.Fragment>
  );
};

export default Apps;
